module.exports = __webpack_public_path__ + "img/logo-white-bg-sprite.dd8de67d.png";